import { render, staticRenderFns } from "./DocumentModificator.vue?vue&type=template&id=0ee70e76"
import script from "./DocumentModificator.vue?vue&type=script&lang=js"
export * from "./DocumentModificator.vue?vue&type=script&lang=js"
import style0 from "./DocumentModificator.vue?vue&type=style&index=0&id=0ee70e76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports